import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { memo, useEffect, useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { FormControl, FormLabel } from '@mui/material';
import { RangeUnitFields } from 'console/tabs/maintenance/notification/range-unit-fields';
const defaultValues = {
    repeat: {
        date: null,
        mileage: null,
        moto_hours: null,
    },
    notify: {
        date: null,
        mileage: null,
        moto_hours: null,
    },
};
const form_control_sx = { gap: 1, flexDirection: 'row' };
export const PlannedMaintenance = memo(function PlannedMaintenance(props) {
    const { maintenances, save_device_settings } = props;
    const planned_notification = useMemo(() => maintenances != null && maintenances.planned_notification != null
        ? maintenances.planned_notification
        : defaultValues, [maintenances]);
    const { watch, control, formState: { isDirty }, getValues, } = useForm({
        defaultValues: planned_notification,
    });
    const notification_date = watch('notify.date');
    const notification_repeat = watch('repeat.date');
    const planned_notification_state = getValues();
    useEffect(() => {
        if (isDirty) {
            const planned_notification_state = getValues();
            save_device_settings({
                maintenances: {
                    history: maintenances?.history ?? [],
                    planned_notification: planned_notification_state,
                },
            });
        }
    }, [notification_date, notification_repeat]);
    return (_jsxs(_Fragment, { children: [_jsxs(FormControl, { component: "fieldset", sx: form_control_sx, children: [_jsx(FormLabel, { component: "legend", children: "\u0420\u0430\u0437 \u0432 ..." }), _jsx(RangeUnitFields, { control: control, control_key: "repeat", hide_field: ['moto_hours', 'mileage'] })] }), _jsxs(FormControl, { component: "fieldset", sx: form_control_sx, children: [_jsx(FormLabel, { component: "legend", children: "\u041D\u0430\u043F\u043E\u043C\u043D\u0438\u0442\u044C \u0437\u0430 ..." }), _jsx(RangeUnitFields, { control: control, control_key: "notify", hide_field: ['moto_hours', 'mileage'] })] })] }));
});
